import { render, staticRenderFns } from "./TradeStats.vue?vue&type=template&id=2614830f&scoped=true&"
import script from "./TradeStats.vue?vue&type=script&lang=js&"
export * from "./TradeStats.vue?vue&type=script&lang=js&"
import style0 from "./TradeStats.vue?vue&type=style&index=0&id=2614830f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2614830f",
  null
  
)

export default component.exports